module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/27 valecek na rezu.jpg";